import { FormProvider, useForm } from 'react-hook-form';
import { useAppSelector, useToast } from '../../../hooks';
import { Button } from '../../Button';
import { Input } from '../../Inputs/Input';
import { formRules } from '../FormRules';
import { useEffect, useState } from 'react';
import { apiService } from '../../../services/api';
import { UsersFormProps } from '../../../pages/Register/form-props.types';
import { UpdateUserReq, UserRole } from '../../../services/api.types';
import { useNavigate } from 'react-router-dom';
import { usersService } from '../../../services/users.service';

interface AdminFormValues {
  displayName: string;
  fullName: string;
  email: string;
  //notifySMS: boolean;
  notifyEmail: boolean;
  notifyWhatsapp: boolean;
  active?: boolean;
  role?: UserRole;
}

export function AdminRegisterForm({
  mode,
  userToUpdate,
}: Readonly<UsersFormProps>) {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const user = useAppSelector((state) => state.user);
  const isAdmin = user?.role === UserRole.ADMIN;
  const navigate = useNavigate();
  const selfEdit = userToUpdate?.id === user?.id;

  const getAdminDefaultValues = (): AdminFormValues => {
    if (userToUpdate && mode === 'UPDATE') {
      return userToUpdate;
    }

    return {
      fullName: '',
      displayName: '',
      email: '',
      notifyEmail: true,
      notifyWhatsapp: true,
    };
  };

  const methods = useForm<AdminFormValues>({
    mode: 'all',
    defaultValues: getAdminDefaultValues(),
  });
  const fullName = methods.watch('fullName');
  useEffect(() => {
    if (mode === 'CREATE') {
      methods.setValue('displayName', fullName);
    }
  }, [fullName, mode, methods]);

  const onSubmit = async (data: AdminFormValues) => {
    setIsLoading(true);

    const updateAPImethod = (data: UpdateUserReq) =>
      userToUpdate && !selfEdit
        ? usersService.updateUserById(userToUpdate.id, data)
        : usersService.updateSelfUser(data);

    if (mode === 'UPDATE') {
      await updateAPImethod({
        fullName: data.fullName,
        displayName: data.displayName,
        email: data.email,
        notifyEmail: data.notifyEmail,
        notifyWhatsapp: data.notifyWhatsapp,
        active: data.active,
        role: data.role,
        [UserRole.ADMIN]: {},
      })
        .then(() => {
          toast.success('Administrador alterado!');
          navigate(-1);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    if (mode === 'CREATE') {
      await apiService
        .registerAdmin({
          ...data,
        })
        .then(() => {
          methods.reset(getAdminDefaultValues());
          toast.success('Administrador cadastrado!');
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="flex flex-col items-center gap-1 w-full box-border pt-2 p-4 justify-between"
      >
        <Input
          name="fullName"
          label="Nome Completo"
          rules={formRules.fullNameRequired}
          disabled={!isAdmin}
        />
        <Input
          name="displayName"
          label="Como gostaria de ser chamado(a)?"
          disabled={!isAdmin}
        />

        <Input
          name="email"
          type="email"
          label="E-mail"
          rules={formRules.emailRequired}
          disabled={!isAdmin}
        />

        <Button
          className="mt-6"
          fullWidth
          type="submit"
          isLoading={isLoading}
          circular
          disabled={!isAdmin}
        >
          {mode === 'CREATE' ? 'Cadastrar' : 'Alterar'}
        </Button>
      </form>
    </FormProvider>
  );
}
